import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { store } from 'redux/store';
import { App } from './App';
import './index.css';

const theme = createTheme({
  palette: {
    primary: {
      main: '#FF1493',
      light: '#FF69B4',
      dark: '#C71585',
      contrastText: '#000000',
    },
    secondary: {
      main: '#FF80AB',
    },
    text: {
      primary: '#000000',
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </Provider>,
);
